/**
 * Information about the status of the returned settings.
 *
 * @deprecated unused and replace by MobizSettingsOrigin
 */
export type MobizSettingsFound = 'Saved' | 'DefaultValue' | 'NotFound';
